import { Button, DialogActions, DialogContent, Typography } from '@customink/pigment-react';
import { isUnknownBraintreeError, KnownErrorFields } from '~/adapters/braintree/errorHandler';
import { EmptyFunction } from '~/adapters/typescript/emptyFunction';
import { ResponsiveDialog } from '~/components/DialogPigment/ResponsiveDialog';
import { HostedFields } from './HostedFields';
import { HostedFieldButtons } from './HostedFieldButtons';
import { useHostedFields } from './HostedFieldsContext';

interface HostedFieldDialogProps {
    open: boolean;
    closeDialog: EmptyFunction;
}

interface HostedFieldAddCardDialogProps extends HostedFieldDialogProps {
    errorFields: KnownErrorFields;
}

function HostedFieldAddCardDialog({ open, closeDialog, errorFields }: HostedFieldAddCardDialogProps) {
    return (
        // keepMounted is necessary so that certain DOM elements in HostedFields are always available for braintree (otherwise it crashes)
        <ResponsiveDialog keepMounted title="Add a New Card" open={open} onClose={closeDialog}>
            <DialogContent>
                <HostedFields errorFields={errorFields} />
            </DialogContent>
            <DialogActions>
                <HostedFieldButtons closeDialog={closeDialog} errorFields={errorFields} />
            </DialogActions>
        </ResponsiveDialog>
    );
}

function HostedFieldUnknownErrorDialog({ open, closeDialog }: HostedFieldDialogProps) {
    return (
        <ResponsiveDialog title="Payment Method Not Added" open={open} onClose={closeDialog}>
            <DialogContent>
                <Typography variant="bodyShort1">
                    We couldn&apos;t save your card at this time. Please try again later or add a different payment
                    method.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>OK</Button>
            </DialogActions>
        </ResponsiveDialog>
    );
}

export function HostedFieldDialog({ open, closeDialog }: HostedFieldDialogProps) {
    const { errorFields } = useHostedFields();
    if (isUnknownBraintreeError(errorFields)) {
        return <HostedFieldUnknownErrorDialog open={open} closeDialog={closeDialog} />;
    }

    return <HostedFieldAddCardDialog open={open} closeDialog={closeDialog} errorFields={errorFields} />;
}
